let accessToken = null;
const clearLocalStorage = (keysToKeepArray) => {
  const keysToKeep = new Set(keysToKeepArray);

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);

    if (!keysToKeep.has(key)) {
      localStorage.removeItem(key);
      i--;
    }
  }
};

export const setAuthToken = (token) => {
  accessToken = token;
};

export const getAuthToken = () => {
  return accessToken;
};

export const clearAuthToken = () => {
  accessToken = null;
  const skipKeys = ["employeeOfficialEmail", "multipleEmployer", "language"];
  if (localStorage.getItem("multipleEmployer") === "0") {
    skipKeys.push("company_url");
  }
  clearLocalStorage(skipKeys);
};
